import Hosts from '../../../../Hosts';

const object_type = '/intranet/maintenance'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/type/${companycode}/active`

const base_endpoint = '/intranet_maintenance_active'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        name: [],
        tag: '',
        file: {
            editable: [],
            pdf: []
        },
        settings: {},
        responsable: {
            edit: {},
            aproval : {},
            remove: {}
        },
        historic: [],
        type: 'active',
        companycode: '',
        active: false,
        avaiable: false
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
}
